/**
 * Animal category emoji mapping utility
 * Maps animal category names to their corresponding emojis
 */

const ANIMAL_EMOJI_MAP = {
  // English names (case-insensitive matching)
  'dogs': '🐕',
  'dog': '🐕',
  'cats': '🐈',
  'cat': '🐈',
  'birds': '🐦',
  'bird': '🐦',
  'fish': '🐟',
  'reptiles': '🦎',
  'reptile': '🦎',
  'small mammals': '🐹',
  'small mammal': '🐹',
  'amphibians': '🐸',
  'amphibian': '🐸',
  'exotic animals': '🦜',
  'exotic animal': '🦜',
  'farm animals': '🐄',
  'farm animal': '🐄',
  'equines': '🐴',
  'equine': '🐴',
  'horse': '🐴',
  'horses': '🐴',
  'wildlife': '🦊',
  'rabbit': '🐰',
  'rabbits': '🐰',
  'hamster': '🐹',
  'hamsters': '🐹',
  'guinea pig': '🐹',
  'guinea pigs': '🐹',
  'turtle': '🐢',
  'turtles': '🐢',
  'snake': '🐍',
  'snakes': '🐍',
  'parrot': '🦜',
  'parrots': '🦜',

  // Greek names
  'σκύλοι': '🐕',
  'σκύλος': '🐕',
  'γάτες': '🐈',
  'γάτα': '🐈',
  'πουλιά': '🐦',
  'πουλί': '🐦',
  'ψάρια': '🐟',
  'ψάρι': '🐟',
  'ερπετά': '🦎',
  'ερπετό': '🦎',
  'μικρά θηλαστικά': '🐹',
  'αμφίβια': '🐸',
  'αμφίβιο': '🐸',
  'εξωτικά ζώα': '🦜',
  'ζώα αγροκτήματος': '🐄',
  'ιπποειδή': '🐴',
  'άγρια ζώα': '🦊',
};

/**
 * Get emoji for an animal category name
 * @param {string} categoryName - The animal category name (English or Greek)
 * @returns {string} The emoji for the category, or a default paw emoji
 */
export const getAnimalEmoji = (categoryName) => {
  if (!categoryName) return '🐾';

  const normalizedName = categoryName.toLowerCase().trim();
  return ANIMAL_EMOJI_MAP[normalizedName] || '🐾';
};

/**
 * Get animal category name with emoji prefix
 * @param {string} categoryName - The animal category name
 * @returns {string} The category name with emoji prefix
 */
export const getAnimalNameWithEmoji = (categoryName) => {
  if (!categoryName) return '';

  const emoji = getAnimalEmoji(categoryName);
  return `${emoji} ${categoryName}`;
};

export default {
  getAnimalEmoji,
  getAnimalNameWithEmoji,
  ANIMAL_EMOJI_MAP,
};
